import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('filters', [
    'dateRangeFilters',
    'dateRangeInsightsFilters',
    'dateRangeDaysFilters',
    'dateRangeReadableFilters',
    'dateRangeWebFilters',
    'deviceFilters',
    'availableInsightsFilters',
    'shiftFilters',
    'activityChangedFilter',
  ]),
}

export const Methods = mapActions('filters', [
  'setDateRangeFilters',
  'setDateRangeFiltersInsights',
  'setDeviceFilters',
  'setAvailableInsightsFilters',
  'setShiftFilters',
  'setDateRangeDays',
  'setactivityChangedFilter',
])
